import type { VideoListItem } from 'models';
import { DataCard, Icon, Text } from 'ui';
import { images } from 'common/utils';
import { useGetVideoStatusTagProperties } from '../../hooks';
import { useGetVideoMedia } from '../../queries';
import { useGetVideoDuration } from './hooks';

type P = {
  getPathToVideoDetail: (id: string) => string;
  showTag?: boolean;
  video: VideoListItem;
};

const VideoCard = ({ getPathToVideoDetail, showTag = true, video }: P) => {
  const { data: trailerData } = useGetVideoMedia({ mediaId: video.trailer?.externalId });

  const duration = useGetVideoDuration(trailerData?.meta.duration);
  const getStatusTagProperties = useGetVideoStatusTagProperties();

  return (
    <DataCard
      description={{
        date: video.recordedAt,
      }}
      image={{
        action: <Icon icon="play-button" size="large" />,
        alt: 'Video cover image',
        meta: duration ? <Text size="small">{duration}</Text> : undefined,
        src: video.coverPhoto?.url ?? images.default.videoCoverPhoto,
      }}
      path={getPathToVideoDetail(video.id)}
      tag={showTag ? getStatusTagProperties({ status: video.status }) : undefined}
      title={video.name}
    />
  );
};

export default VideoCard;
